module KendoWidgets
{
	export class ComboBoxOptions implements kendo.ui.ComboBoxOptions
	{
		dataTextField?: string;
		dataValueField?: string;
		width?: string | number;
		placeholder?: string;
		autoWidth?: boolean;
		wrapper?: string | JQuery | Element;

		addButton?: boolean;
		clearButton?: boolean;
		dataSource?: any | any | kendo.data.DataSource;
		enable?: boolean;
		filter?: string;
		highlightFirst?: boolean;
		index?: number;
		suggest?: boolean;
		template?: string | Function;
		text?: string;
		value?: string;
		autoBind?: boolean;
		css?: string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		type?: KendoWidgets.ComboBoxFilterTypeEnum;
		iconPath?: string;
		textAlign?: TextAlignEnum;
		parameters?(): ComboBoxTypedParameters;

		/** Allowed search and free text */
		acceptFreeText?: boolean;
		/** Only use if combo without value (Ex: professions) */
		onlyTextCombo?: boolean;

		change?(e: kendo.ui.ComboBoxChangeEvent): void;
		close?(e: kendo.ui.ComboBoxCloseEvent): void;
		dataBound?(e: kendo.ui.ComboBoxDataBoundEvent): void;
		filtering?(e: kendo.ui.ComboBoxFilteringEvent): void;
		open?(e: kendo.ui.ComboBoxOpenEvent): void;
		cascade?(e: kendo.ui.ComboBoxCascadeEvent): void;
		clickOnAddButton?(e: kendo.ui.ButtonClickEvent): void;
	}

	export class ComboBox extends kendo.ui.ComboBox implements KendoWidget, IControlWithDatasource
	{
		private _type: ComboBoxFilterTypeEnum;
		private _btnAdd: KendoWidgets.Button;
		private _actualItem: ComboBoxItem | null;
		private _firstLoad: boolean;
		private _authKeyWebApi: string;
		private _dataSourceMap: Map<string, string>;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.ComboBox; }

		constructor(element: Element, options?: KendoWidgets.ComboBoxOptions)
		{
			if (options == null)
				options = new KendoWidgets.ComboBoxOptions();

			if (options.dataTextField == null) options.dataTextField = "text";
			if (options.dataValueField == null) options.dataValueField = "value";
			if (options.width == null) options.width = 190;
			if (options.addButton == null) options.addButton = false;
			if (options.type == null) options.type = KendoWidgets.ComboBoxFilterTypeEnum.Default;
			if (options.acceptFreeText == null) options.acceptFreeText = false;
			if (options.onlyTextCombo == null) options.onlyTextCombo = false;
			if (options.autoWidth == null) options.autoWidth = true;
			if (options.filter == null) options.filter = "contains";
			if (options.suggest == null) options.suggest = true;
			if (options.textAlign == null) options.textAlign = TextAlignEnum.Left;

			let realDataSource = null;
			if (options.dataSource != null)
			{
				realDataSource = options.dataSource;
				options.dataSource = null;
			}

			//#region Placeholder
			if (options.placeholder == null)
			{
				if (options.type == ComboBoxFilterTypeEnum.Default)
					options.placeholder = "Seleziona...";
				else
					options.placeholder = "Cerca...";
			}
			//#endregion

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Change
			let changeUserOverride = options.change;
			options.change = function (e: kendo.ui.ComboBoxChangeEvent)
			{
				// Set actual item
				let comboBox = (e.sender as KendoWidgets.ComboBox);
				let comboBoxItem = comboBox.selectedItem();
				if (options!.onlyTextCombo)
					comboBoxItem.value = comboBox.text();

				comboBox._actualItem = (comboBoxItem == null || comboBoxItem.value == "") ? null : comboBoxItem;

				// User override
				if (changeUserOverride != null)
					changeUserOverride(e);
			}
			//#endregion

			//#region Close
			options.close = function (e: kendo.ui.ComboBoxCloseEvent)
			{
				//#region Clear timer
				let timer = e.sender.element.attr("timer");
				if (timer != null && timer != "")
					clearTimeout(parseInt(timer));
				//#endregion

				if (!options!.acceptFreeText)
				{
					let comboBox = (e.sender as KendoWidgets.ComboBox);
					if (comboBox._actualItem == null || !comboBox.getAllValues().toStringArrayList().includes(comboBox.value()))
						comboBox.clear();
					else
					{
						if (comboBox.type() == ComboBoxFilterTypeEnum.Default)
							comboBox.setValue(comboBox._actualItem.value);
						else
							comboBox.setValue(comboBox._actualItem);
					}
				}
			}
			//#endregion

			super(element, options);
			let that = this;
			element.parentElement!.id = element.id + "Parent";
			$(element).parent().addClass("controlParent");

			this._dataSourceMap = new Map<string, string>();
			if (realDataSource != null)
				this.setItems(realDataSource);

			//#region Open at focus and click
			$(this.input).on("focus", () =>
			{
				let sUsrAg = navigator.userAgent;
				if (sUsrAg.indexOf("Safari") == -1)
					window.setTimeout(() => that.open(), 100);

				if (options!.type != ComboBoxFilterTypeEnum.Default)
					that.readDatasourceTypedCombo();
			});
			//#endregion

			//#region Type
			this._authKeyWebApi = "h]K)x@)k2j.@{=7D";
			this.type((options as KendoWidgets.ComboBoxOptions).type);
			this.createTypedCombo();
			//#endregion

			//#region Add button
			if (options!.addButton && !this._firstLoad)
			{
				let clickOnAddButtonUserOverride = options.clickOnAddButton;
				$(element.parentElement!).addClass("k-combobox-withAddButton");

				// Button
				$("#" + element.id + "AddButton").remove();
				let buttonElement = document.createElement("em");
				$(buttonElement).attr("id", element.id + "AddButton");
				$(buttonElement).addClass("k-combobox-addButton");
				this._btnAdd = <KendoWidgets.Button>$(buttonElement).kendoButton(
					{
						icon: "plus",
						click: function (e)
						{
							if (clickOnAddButtonUserOverride != null)
								clickOnAddButtonUserOverride(e);
						}
					}).data("kendoButton");
				buttonElement.style.cssText += "padding-top: 4px !important; padding-left: 4px! important; border-top-left-radius: 0px; border-bottom-left-radius: 0px; background-color: #e4e7eb;";
				$(element.parentElement!.firstElementChild!).append(buttonElement);

				// Remove radius
				if (element.parentElement != null && element.parentElement!.firstElementChild != null)
				{
					let spanSelect = (element.parentElement!.firstElementChild!.getElementsByClassName("k-select")[0]) as HTMLElement;
					if (spanSelect != null)
						spanSelect.style.cssText += "border-radius: 0px;";
				}

				// Adjust close icon position
				$(element).parent().find(".k-i-close").css("right", "54px");
			}
			//#endregion

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");

							if (element.parentElement != null)
							{
								element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
								element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							}
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");

							if (element.parentElement != null)
							{
								element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
								label.style.cssText += "margin-right: 5px";
							}
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");

							if (element.parentElement != null)
							{
								element.parentElement!.append(label);
								label.style.cssText += "margin-left: 5px";
							}
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");

							if (element.parentElement != null)
							{
								element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
								element.parentElement!.append(label);
							}
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Text align
			switch (options.textAlign)
			{
				case TextAlignEnum.Left: $(element.parentElement!).find(".k-input").css("text-align", "left"); break;
				case TextAlignEnum.Center: $(element.parentElement!).find(".k-input").css("text-align", "center"); break;
				case TextAlignEnum.Right: $(element.parentElement!).find(".k-input").css("text-align", "right"); break;
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).parentElement!.style.cssText += options.css;
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().wrap(options!.wrapper!));
			//#endregion
		}

		//#region Filtered combo
		private readDatasourceTypedCombo()
		{
			if (this.text().length == 0)
				return;

			let request: any = {};
			request.AuthKey = this._authKeyWebApi;
			request.searchText = this.text();

			//#region Parameters
			let typedComboInfo = this.getTypedComboInfo();
			let parameters = null;
			if ((this.options as ComboBoxOptions).parameters != null)
				parameters = (this.options as ComboBoxOptions).parameters!();

			if (parameters != null)
			{
				let propNames = Object.getOwnPropertyNames(parameters);
				for (let propName of propNames)
					(request as any)[propName] = (parameters as any)[propName];
			}
			//#endregion

			//#region Web api call
			let jsonString = JSON.stringify(request);
			let that = this;
			$.ajax({
				type: "POST",
				contentType: "application/json",
				data: jsonString,
				method: "POST",
				processData: false,
				dataType: "json",
				url: "/api/ComboBoxWebApi/" + typedComboInfo.webApiMethodName,
				success: (items) => that.setItems(items)
			});
			//#endregion
		}

		private createTypedCombo()
		{
			let typedComboInfo = this.getTypedComboInfo();

			//#region Icon & template
			if (typedComboInfo.iconPath != null)
				this.element.parent().find("input.k-input")[0].style.cssText += `background-image: url(` + typedComboInfo.iconPath + `); background-position: 4px 5px; background-repeat: no-repeat; text-indent: 21px !important;`;

			if (typedComboInfo.template != null)
				this.setOptions({ template: typedComboInfo.template });
			//#endregion

			//#region Datasource reading
			if (this.type() != ComboBoxFilterTypeEnum.Default)
			{
				let changeUserOverride = this.options.change;
				this.setOptions(
					{
						change: (e: kendo.ui.ComboBoxChangeEvent) =>
						{
							let item: any = this.dataItem(this.select());
							if (item == null)
								this.dataSource.data([]);

							if (changeUserOverride != null)
								changeUserOverride(e);

							if (this._btnAdd != null)
								this.setAddButtonIcon();
						}
					});

				$(this.input).on("input", () =>
				{
					this.dataSource.data([]);
					if (this.text().length == 0)
						return;

					let timer = this.element.attr("timer");
					if (timer != null && timer != "")
						clearTimeout(parseInt(timer));

					this.element.attr("timer", setTimeout(() => this.readDatasourceTypedCombo(), 200).toString());
				});
			}
			//#endregion
		}

		private getTypedComboInfo()
		{
			let typedComboInfo = new TypedComboInfo();
			switch (this.type())
			{
				case ComboBoxFilterTypeEnum.Default:
					{
						typedComboInfo.iconPath = (this.options as KendoWidgets.ComboBoxOptions).iconPath;
					}
					break;
				case ComboBoxFilterTypeEnum.Subject:
					{
						typedComboInfo.webApiMethodName = "GetAllSubjects";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/subject.png";
						typedComboInfo.template = "<div style='width: 100%; line-height:normal; padding-bottom:5px;'>#= data.displayForCombo #</div>";
					}
					break;
				case ComboBoxFilterTypeEnum.City:
					{
						typedComboInfo.webApiMethodName = "GetAllCities";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/city.png";
					}
					break;
				case ComboBoxFilterTypeEnum.Country:
					{
						typedComboInfo.webApiMethodName = "GetAllCountries";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/globe.png";
					}
					break;
				case ComboBoxFilterTypeEnum.Suppliers:
					{
						typedComboInfo.webApiMethodName = "GetAllSuppliers";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/subject.png";
					}
					break;
				case ComboBoxFilterTypeEnum.Doctor:
					{
						typedComboInfo.webApiMethodName = "GetAllDoctors";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/doctor.png";
						typedComboInfo.template = "<div style='width: 100%; line-height:normal; padding-bottom:5px;'>#= data.displayForCombo #</div>";
					}
					break;
				case ComboBoxFilterTypeEnum.Asl:
					{
						typedComboInfo.webApiMethodName = "GetAllAsl";
						typedComboInfo.iconPath = "/TypeScript/Kendo/Extensions/Images/asl.png";
					}
					break;
				case ComboBoxFilterTypeEnum.IcdQueries:
					{
						typedComboInfo.webApiMethodName = "GetAllIcd9";
					}
					break;
				case ComboBoxFilterTypeEnum.RentEntity:
					{
						typedComboInfo.webApiMethodName = "GetAllRentEntities";
						typedComboInfo.template = "<div style='width: 100%;'><b>#:data.displaySubgroup#</b><br />Codice #:data.code# - matricola #:data.serialNumber#<br /><i>#:data.displayMainGroup# - #:data.displayGroup#</i><br /><hr style='width: 100%;'></div>";
					}
					break;
				case ComboBoxFilterTypeEnum.RentContract:
					{
						typedComboInfo.webApiMethodName = "GetAllRentContracts";
						typedComboInfo.template = "<div style='width: 100%;'><b>#:data.text#</b><br />#: data.patientDisplayName #<br />#:data.startDate != null ? data.startDate : \"(n/d)\"# - #:data.endDate != null ? data.endDate : \"(n/d)\"#<br /><i>#:data.displayEntity#</i><br /><hr style='width: 100%;'></div>";
					}
					break;
				case ComboBoxFilterTypeEnum.Entity:
					{
						typedComboInfo.webApiMethodName = "GetAllEntities";
					}
					break;
				case ComboBoxFilterTypeEnum.Documents:
					{
						typedComboInfo.webApiMethodName = "GetAllDocuments";
						typedComboInfo.template = "<div style='width: 100%;'>#:data.causalCode# <b>#:data.number#</b><br />#:data.dateString#<br />#:data.displaySource# - #:data.displayDestination#<br /><hr style='width: 100%;'></div>";
					}
					break;
				case ComboBoxFilterTypeEnum.Companies:
					{
						typedComboInfo.webApiMethodName = "GetAllCompanies";
					}
					break;
			}
			return typedComboInfo;
		}
		//#endregion

		setItems(items: any[])
		{
			if (items == null) items = [];
			this.setAddButtonIcon();
			this.dataSource.data(items);

			for (let item of items)
			{
				let key = String(item["value"]);
				if (key != "" && key != null)
				{
					if (!this._dataSourceMap.has(key))
						this._dataSourceMap.set(key, key);
				}
			}
		}

		getItems(): any[]
		{
			return this.dataSource.data() as any as any[];
		}

		public getAllValues()
		{
			return this.getItems().map(k => k.value);
		}

		addItems(items: any[])
		{
			for (let item of items)
				this.dataSource.data().push(item);
		}

		/**
		 * @param itemOrId: if the structure contains "id" property you can pass the id (string or number), otherwise
		 * you have to pass the item from dataSource
		 */
		removeItem(itemOrId: any | string | number)
		{
			if (typeof itemOrId == "string" || typeof itemOrId == "number")
			{
				let foundedItem = this.dataSource.data().filter(k => (k as any).value == itemOrId)[0];
				this.dataSource.data().remove(foundedItem);
			}
			else
				this.dataSource.data().remove(itemOrId);
		}

		removeItems(items: any[])
		{
			for (let item of items)
				this.dataSource.data().remove(item);
		}

		clear()
		{
			this.value("");
			this._actualItem = null;
			this.setAddButtonIcon();

			if (this.type() != ComboBoxFilterTypeEnum.Default)
				this.clearItems();
		}

		clearItems()
		{
			this._dataSourceMap.clear();
			this.dataSource.data([]);
			this._actualItem = null;
			this.setAddButtonIcon();
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().show();
				else
					this.element.parent().hide();
			}

			return this.element.parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}

		width(width?: string | number)
		{
			if (width != null)
				this.element.parent().width(width);

			return this.element.parent().width();
		}

		selectedItem()
		{
			return this.dataItem(this.select());
		}

		value(value?: string)
		{
			if (value != null)
			{
				let onlyTextCombo = (this.options as KendoWidgets.ComboBoxOptions).onlyTextCombo;
				if (value != "" && !this._dataSourceMap.has(String(value)) && !onlyTextCombo)
					value = "";

				let item = new ComboBoxItem();
				item.value = value;

				if (onlyTextCombo)
				{
					item.text = value;
					super.text(value);
				}
				else
					super.value(value);

				this._actualItem = item;
			}

			return (super.text() == super.value() && (this.options as KendoWidgets.ComboBoxOptions).acceptFreeText) ? "" : super.value();
		}

		setValue(value?: any, triggerChange?: boolean, callback?: any)
		{
			this._actualItem = value;

			if (this.type() == ComboBoxFilterTypeEnum.Default)
				this.value(value);
			else
			{
				if (triggerChange == null) triggerChange = true;
				$(this.input).off("input");
				if (value != null)
				{
					this.clear();
					this.dataSource.data([value]);
					this.select(0);
				}
				this.createTypedCombo();
			}

			if (this._btnAdd != null && value != null)
				this.setAddButtonIcon();

			if (triggerChange == true)
				this.trigger("change", {
					sender: this,
					callback: callback
				});
		}

		private setAddButtonIcon()
		{
			if (this._btnAdd != null && this._btnAdd.element != null)
			{
				let spanIcon = this._btnAdd.element.find(".k-icon");
				if (spanIcon != null && spanIcon[0] != null)
				{
					if (this.value() != null && this.value() != "")
					{
						spanIcon.removeClass("k-i-plus");
						spanIcon.addClass("k-i-edit");
					}
					else
					{
						spanIcon.removeClass("k-i-edit");
						spanIcon.addClass("k-i-plus");
					}
				}
			}
		}

		type(type?: ComboBoxFilterTypeEnum)
		{
			if (type != null)
				this._type = type;

			return this._type;
		}

		labelText(text?: string)
		{
			let label = this.element.parent().find(".k-label");
			if (text != null && label != null && label.length > 0)
				label.text(text);

			return (label != null && label.length > 0) ? label.text() : "";
		}

		placeholder(placeholder?: string)
		{
			let input = this.element.parent().find(".k-input");
			if (placeholder != null)
				input.attr("placeholder", placeholder);

			return input.attr("placeholder");
		}

		getOptions()
		{
			return (this.options as ComboBoxOptions);
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
	}

	ComboBox.fn = ComboBox.prototype;
	ComboBox.fn.options = $.extend(true, {}, kendo.ui.ComboBox.fn.options);
	ComboBox.fn.options.name = "ComboBox";
	kendo.ui.plugin(ComboBox);

	//Non aggiungere nessun tipo senza chiedere autorizzazione e solo con WebService
	export enum ComboBoxFilterTypeEnum
	{
		Default,
		Subject,
		Doctor,
		City,
		Asl,
		IcdQueries,
		Suppliers,
		Country,
		RentEntity,
		RentContract,
		Entity,
		Documents,
		Companies
	}

	class TypedComboInfo
	{
		public webApiMethodName: string;
		public iconPath?: string;
		public template?: string;
	}

	class ComboBoxItem
	{
		public text: string;
		public value: string;
	}

	class ComboBoxTypedParameters
	{
		/**City */
		onlyActive?: boolean;

		/**Rent entity */
		subgroupId?: number;
	}
}

interface JQuery
{
	kendoComboBox(options?: KendoWidgets.ComboBoxOptions): JQuery;
}